// extracted by mini-css-extract-plugin
module.exports = {"cookiePreferencesButton":"cookiePreferencesButton_cookiePreferencesButton__SInC4","image":"cookiePreferencesButton_image__8uNG4"};